import { createSelector } from "reselect";
import { defaultCamerasProfileWidgets } from "orion-components/Profiles/Utils/CameraProfileWidgets";
import unionBy from "lodash/unionBy";
import { widgetStateSelector } from "orion-components/AppState/Selectors";

const getWidgetState = (state) => widgetStateSelector(state)?.widgetOrder || [];

export const cameraProfileConfig = createSelector([getWidgetState], (widgetState) => {
	const defaultTypes = ["linked_items", "activities", "live_camera", "files", "map", "details", "alerting_zones"];

	const filteredDefault = defaultCamerasProfileWidgets.filter((widget) => defaultTypes.includes(widget.id));

	const widgetConfig = widgetState.length > 0 ? unionBy(widgetState, filteredDefault, "id") : filteredDefault;

	return widgetConfig;
});

const getFovState = (state) => state?.appState?.persisted?.activeFOVs;

export const persistedCameraFovs = createSelector([getFovState], (fovState) => (cameraId) => {
	if (fovState?.[cameraId]) {
		return true;
	}
	return false;
});
